import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { Avatar, Dropdown, Tooltip, Layout, Menu, Typography, Col, Row } from 'antd';
import { CaretDownOutlined, LogoutOutlined, FlagOutlined, UserOutlined } from '@ant-design/icons';
import Spain from '../../assets/Banderas/Spain.svg';
import Cataluna from '../../assets/Banderas/Cataluna.svg';
import EstadosUnidos from '../../assets/Banderas/EstadosUnidos.png';
import faqEV from '../../assets/icons/faqEV.png';
import contactoEv from '../../assets/icons/contactoEv.png';

import ContactoPage from '../../Pages/ContactoPage';
import axios from 'axios';
import { useTranslation, withTranslation } from 'react-i18next';
import i18n from '../../i18n';
import env from '../../environment';
import { useSelector, useDispatch } from 'react-redux';
import { callAct, changeRol } from '../../store/auth/actions';
import { logout } from '../../store/auth/actions';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { commonNotifications } from 'mortgage-documents/src/document-boxes/CommonItems';

const { Header } = Layout;
const { Text } = Typography;

function HeaderComponent() {
	const dispatch = useDispatch();
	const [taskToEdit, setTaskToEdit] = useState(null);
	const [showModal, setShowModal] = useState(false);
	const [dataPersonal, setDataPersonal] = useState(null);
	const changeCallAct = useSelector((state) => state.auth.callAct);
	const rolUser = useSelector((state) => state.auth.roles);
	const dataProfile = useSelector((state) => state.data.dataProfile);
	const allRoles = dataProfile?.roles?.length > 0 ? dataProfile.roles : 'client';
	let temp =
		allRoles && Array.isArray(allRoles)
			? allRoles
			: allRoles && allRoles.length === 1 && allRoles[0] === 'realestate'
			? allRoles
			: allRoles && allRoles.split(',');
	let arrayRoles = temp;

	const userToken = useSelector((state) => state.auth.token);
	const { t } = useTranslation();
	const analytics = getAnalytics();

	const hideAddTaskModal = () => {
		setShowModal(false);
		setTaskToEdit(null);
	};

	useEffect(() => {
		dataPersonalOperation();
	}, [changeCallAct]);

	useEffect(() => {
		if (rolUser === 'realestate' && arrayRoles[0] === 'hadmin') {
			dispatch(changeRol('realestate'));
			//allRoles[0] = "realestate"
			localStorage.setItem('allRoles', ['realestate', 'client']);
		}
		dataPersonalOperation();
	}, []);

	const dataPersonalOperation = () => {
		axios
			.get(`${env.api.url}/v1/user/profile`, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then((response) => {
				setDataPersonal(response.data.data.profile);
				dispatch(callAct(false));
			});
	};

	const enviarNuevoMensaje = (values) => {
		axios
			.post(`${env.api.url}/v1/user/contact-email`, values, {
				headers: { Authorization: `Bearer ${userToken}` }
			})
			.then(() => {
				commonNotifications('success', 'Mensaje enviado', 'Su mensaje fue enviado', true);
			});
		setShowModal(false);
	};

	const changeLanguage = (lng) => {
		axios.patch(
			`${env.api.url}/v1/user/update-user-language`,
			{
				language: lng
			},
			{
				headers: { Authorization: `Bearer ${userToken}` }
			}
		);
		i18n.changeLanguage(lng);
	};

	const subMenu1 = (
		<Menu>
			<Menu.Item onClick={() => changeLanguage('es')}>
				<img src={Spain} alt="SpainFlag" height="15px" style={{ marginRight: '5px' }} />
				{t('form.es')}
			</Menu.Item>

			<Menu.Item onClick={() => changeLanguage('en')}>
				<img src={EstadosUnidos} alt="EUFlag" height="15px" style={{ marginRight: '5px' }} />
				{t('form.en')}
			</Menu.Item>
			<Menu.Item onClick={() => changeLanguage('cat')}>
				<img src={Cataluna} alt="CataloniaFlag" height="15px" style={{ marginRight: '5px' }} />
				{t('form.cat')}
			</Menu.Item>
		</Menu>
	);

	const logoutUser = () => {
		logEvent(analytics, 'select_content', {
			content_type: 'configuration.list',
			content_id: 'user.logout'
		});
		dispatch(logout({ history }));
	};

	const menu = (
		<Menu>
			<Menu.Item style={{ display: 'flex' }}>
				<FlagOutlined style={{ marginTop: '5px' }} />
				<Dropdown overlay={subMenu1} placement="bottom">
					<Text style={{ marginLeft: 12 }}>{t('init.languages')}</Text>
				</Dropdown>
			</Menu.Item>

			<Menu.Item danger onClick={logoutUser}>
				<LogoutOutlined />
				<Text style={{ marginLeft: 12 }}>{t('init.logout')}</Text>
			</Menu.Item>
		</Menu>
	);

	const showSendMessagesModal = () => {
		setShowModal(true);
	};

	return (
		<Row>
			<Col sm={24} xs={24} lg={24} xl={24}>
				<Header
					className="ant-layout-header g-header"
					style={{
						position: 'relative',
						zIndex: 3,
						backgroundColor: '#FFFFFF',
						display: 'flex',
						justifyContent: 'space-between',
						borderBottom: '1px solid rgba(64, 64, 64, 0.08)'
					}}>
					<div
						style={{
							marginLeft: 24,
							display: 'flex',
							alignSelf: 'center'
						}}>
						<img src="/images/engel-logo-desktop.svg" style={{ height: 16 }} alt="engelLogo" />
					</div>
					<div
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center'
						}}>
						{/*<Tooltip
							placement="bottom"
							title={t('header.help')}
							color={'#262626'}
							overlayClassName="toolTipProperty">
							<NavLink to="/help" style={{ marginTop: 15 }}>
								<img src={faqEV} alt="Info" style={{ height: '24px', marginRight: 24 }} />
							</NavLink>
						</Tooltip>*/}
						{rolUser !== 'realestate' ? (
							<Tooltip
								placement="bottom"
								title={t('header.contact')}
								color={'#262626'}
								overlayClassName="toolTipProperty">
								<img
									src={contactoEv}
									alt="Contacto"
									style={{
										marginTop: '1px',
										height: '24px',
										cursor: 'pointer',
										marginRight: 24
									}}
									onClick={showSendMessagesModal}
								/>
							</Tooltip>
						) : null}

						<ContactoPage
							key={taskToEdit}
							visible={showModal || taskToEdit}
							onCreate={enviarNuevoMensaje}
							onCancel={hideAddTaskModal}
							width={800}
							taskToEdit={taskToEdit}
							dataPersonal={dataPersonal}
						/>

						{dataProfile && dataProfile.avatar ? (
							<Tooltip
								placement="bottom"
								title={dataProfile ? dataProfile.name : 'Usuario'}
								overlayClassName="toolTipProperty"
								color={'#262626'}>
								{/* <NavLink
									to={{
										pathname: `/my-account`,
										state: {
											dataPersonal: dataPersonal
										}
									}}> */}
								<Avatar
									size={24}
									src={`data:image/png;base64,${dataProfile && dataProfile.avatar.data}`}
								/>
								{/* </NavLink> */}
							</Tooltip>
						) : (
							<Tooltip
								placement="bottom"
								title={dataProfile ? dataProfile.name : 'Usuario'}
								overlayClassName="toolTipProperty"
								color={'#262626'}>
								<Avatar size={24} icon={<UserOutlined />} />
								{/* </NavLink> */}
							</Tooltip>
						)}
						{menu && subMenu1 && (
							<Dropdown overlay={menu} placement="bottomRight" arrow>
								<CaretDownOutlined
									style={{
										color: '#666666',
										marginRight: '20px',
										marginLeft: '7px'
									}}
								/>
							</Dropdown>
						)}
					</div>
				</Header>
			</Col>
		</Row>
	);
}

export default withTranslation()(HeaderComponent);
